// Core
import styled, { css } from 'styled-components';

export const InputWrapper = styled.div`
  label {
    font-size: 0.9rem;
    margin-bottom: 10px;
    display: block;
    font-weight: 600;
  }

  textarea {
    display: block;
    width: 100%;
    font-size: 0.9rem;
    padding: 20px;
    border-radius: 5px;
    font-weight: 400;
    color: #fff;
    resize: none;
    height: 250px;
    transition: all 0.1s ease 0s;
    border: 1px solid transparent;
    outline: none;
    background-color: #333;
    font-style: italic;
    ${({ height }) =>
    height &&
    css`
        height: ${ height }px;
    `}
    transition: 0.1s;
  }

  textarea::placeholder {
    color: #ffffff59;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  ${({ error }) =>
    error &&
    css`
      label {
        color: #e35061;
        font-weight: 600;
      }
      p {
        color: #e35061 !important;
        font-weight: 400;
        font-size: 14px !important;
        text-align: left;
        margin: 2px 0px 0px 20px;
      }
      textarea {
        border-color: #e35061 !important;
      }
    `}

    
`;
